// @mui
import { styled, alpha } from "@mui/material/styles";
import {
  Toolbar,
  Tooltip,
  IconButton,
  Typography,
  OutlinedInput,
  InputAdornment,
  Button,
} from "@mui/material";
import Iconify from "@stories/atoms/Iconify/Iconify";
import { StyledButton } from "@stories/atoms/StyledButton/StyledButton";

const transparent = alpha("#b3b3b3", 0.16);

const StyledRoot = styled(Toolbar)(({ theme }) => ({
  height: 96,
  display: "flex",
  justifyContent: "space-between",
  padding: theme.spacing(0, 1, 0, 3),
}));

const StyledSearch = styled(OutlinedInput)(({ theme }) => ({
  width: 240,
  transition: theme.transitions.create(["box-shadow", "width"], {
    easing: theme.transitions.easing.easeInOut,
    duration: theme.transitions.duration.shorter,
  }),
  "&.Mui-focused": {
    width: 320,
    boxShadow: `0 8px 16px 0 ${transparent}`,
  },
  "& fieldset": {
    borderWidth: `1px !important`,
    borderColor: `${alpha(theme.palette.grey[500], 0.32)} !important`,
  },
}));

// ----------------------------------------------------------------------

interface TableToolbarProps {
  loading: boolean;
  buttonTitle?: string;
  searchTitle?: string;
  numSelected: number;
  filterName: string;
  handleOpen: () => void;
  onFilter: (event: any) => void;
}

export default function ListTableToolbar({
  loading,
  buttonTitle,
  searchTitle,
  numSelected,
  filterName,
  handleOpen,
  onFilter,
}: TableToolbarProps) {
  return (
    <StyledRoot
      sx={{
        ...(numSelected > 0 && {
          color: "primary.main",
          bgcolor: "primary.lighter",
        }),
      }}
    >
      {numSelected > 0 ? (
        <Typography component="div" variant="subtitle1">
          {numSelected} selected
        </Typography>
      ) : searchTitle ? (
        <StyledSearch
          value={filterName}
          onChange={onFilter}
          placeholder={searchTitle}
          startAdornment={
            <InputAdornment position="start">
              <Iconify
                icon="eva:search-fill"
                sx={{ color: "text.disabled", width: 20, height: 20 }}
              />
            </InputAdornment>
          }
        />
      ) : null}

      {numSelected > 0 ? (
        <Tooltip title="Delete">
          <IconButton>
            <Iconify icon="eva:trash-2-fill" />
          </IconButton>
        </Tooltip>
      ) : buttonTitle ? (
        <StyledButton
          onClick={handleOpen}
          variant="contained"
          disabled={loading}
          startIcon={<Iconify icon="eva:plus-fill" />}
        >
          {buttonTitle}
        </StyledButton>
      ) : null}
    </StyledRoot>
  );
}
